// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__OZ_BU","img":"styles_img__zechK"};